define(['jquery',
        'core/dynamic-forms'],
    function($) {

        return {'init': function() {}};

    }
);
